<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data">
      <vx-card :title="titleCard" class="mb-base">
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <div>
              <vs-input class="w-full mt-1" label="Código del caso" v-model="casoId" v-validate="'required'"
                name="casoId" :disabled="true" />
              <span class="text-danger text-sm" v-show="
                errors.has('casoId') || formerr.includes('casoId')
              ">Por favor ingrese el código</span>

              <div class="w-full mt-1">
                <label for="casoDescripcion" class="vs-input--label">Descripción del caso</label>
                <vs-textarea class="w-full mb-0" v-model="casoDescripcion" v-validate="'required'"
                  name="casoDescripcion" :disabled="true" />
                <span class="text-danger text-sm"
                  v-show="errors.has('casoDescripcion') || formerr.includes('casoDescripcion')">Por favor ingrese la
                  descripci&oacute;n</span>
              </div>
            </div>
          </div>

          <div class="vx-col w-full md:w-1/2">
            <div>
              <div class="w-full mt-1">
                <label for="files" class="vs-input--label">Adjuntar archivos</label>
                <file-pond name="test" ref="pond" label-idle="Suelta los archivos aquí..." class="w-full"
                  allow-multiple="true" accepted-file-types="image/jpeg, image/png" v-on:addfile="handleFilePondAddFile"
                  v-on:removefile="handleFilePondRemoveFile" v-on:init="handleFilePondInit" />
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <div class="vx-col w-full flex" id="account-manage-buttons">
        <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="actionSaveData">Guardar</vs-button>
        <vs-button type="border" color="danger" icon-pack="feather" @click="closeSidebar">Cancelar</vs-button>
      </div>
    </div>

    <vs-prompt
      color="success"
      @accept="this.closeConfirmDialog"
      @cancel="this.closeConfirmDialog"
      @close="this.closeConfirmDialog"
      :title="'Aviso'"
      acceptText="Aceptar"
      cancelText="Cancelar"
      :active.sync="activePrompt2">
       <div class="con-exemple-prompt">
          <p>{{this.infoConfirmText}}</p>
       </div>
     </vs-prompt>
  </div>
</template>

<script>
import CasoSidebar from '@/views/caso/CasoSidebar.vue'
import CasoModule from '@/store/caso-module/moduleDataList.js'
import ArchivoAdjuntoCasoModule from '@/store/archivo-adjunto-caso-module/moduleDataList.js'
import EtapaCasoModule from '@/store/etapa-caso-module/moduleDataList.js'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish as SpanishLocale } from 'flatpickr/dist/l10n/es.js'

export default {
  components: {
    Datepicker,
    CasoSidebar,
    flatPickr
  },
  props: {
    propEtapaData: {
      type: Object,
      default: () => { }
    },
    licitacionProp: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      titleCard: '', // Crear/Modificar Etapa
      modeCreate: true, // Crear => true/Modificar => false
      formerr: [], // Crear => true/Modificar => false,
      etapa: {},
      casoId: '',
      casoDescripcion: '',
      myFiles: [],
      activePrompt2: false,
      infoConfirmText: '',
      id: -1,
      name: '',
      nit: '',
      representative: '',
      address: '',
      phone: '',
      email: '',
      user_data: {},
      user_not_found: false,
      dob: new Date(),
      configdateIni: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S ',
        locale: SpanishLocale,
        enableSeconds: true,
        maxDate: null
      },
      configdateFin: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S ',
        locale: SpanishLocale,
        enableSeconds: true,
        minDate: null
      }
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    },
    validateForm () {
      return !this.errors.any() && this.formerr.length <= 0
    },
    casoData () {
      return this.$store.state.CasoModule.caso_by_id
    }
  },
  created () {
    this.initParams()
    this.initListOfValues()
  },
  watch: {
    propEtapaData () {
      this.initParams()
    },
    licitacionProp () {
      this.initParams()
    }
  },
  methods: {
    initListOfValues () {
      if (!CasoModule.isRegistered) {
        this.$store.registerModule('CasoModule', CasoModule)
        CasoModule.isRegistered = true
      }
      if (!ArchivoAdjuntoCasoModule.isRegistered) {
        this.$store.registerModule('ArchivoAdjuntoCasoModule', ArchivoAdjuntoCasoModule)
        ArchivoAdjuntoCasoModule.isRegistered = true
      }
    },
    initParams (force = false) {
      console.log('data, ', this.propEtapaData)
      console.log('casoData, ', this.casoData)
      if (
        force ||
        (this.casoData !== null && this.casoData.id === null) ||
        this.casoData.id === undefined ||
        this.casoData.id === ''
      ) {
        //Se Utiliza JSON.parse para evitar que la variable quede bindeada al estado en vuex
        this.etapa = JSON.parse(JSON.stringify(this.propEtapaData))
        this.modeCreate = true
        this.titleCard = 'Adjuntar archivo'
        this.casoId = null
        this.casoDescripcion = ''
        this.myFiles = []
      } else {
        this.modeCreate = false
        this.etapa = JSON.parse(JSON.stringify(this.propEtapaData))
        this.titleCard = 'Adjuntar archivo'
        this.casoId = this.casoData.id
        this.casoDescripcion = this.casoData.descripcion
        this.myFiles = []
      }

      // Si llega la contratación, asignarsela a la etapa
      //console.log('Pregunto si llega la contratación: ', this.licitacionProp)
      if (
        this.licitacionProp !== undefined &&
        this.licitacionProp.IDLICITACION !== null &&
        this.licitacionProp.IDLICITACION !== undefined &&
        this.licitacionProp.IDLICITACION !== ''
      ) {
        this.etapa.IDLICITACION = this.licitacionProp.IDLICITACION
        console.log('Asignando la contratación: ', this.etapa)
      }

      this.$validator.reset()
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la Etapa "${this.etapaName}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    displayMessage () {
      this.$vs.dialog({
        color: 'primary',
        title: 'Modificar registro',
        text: `Modificación de Etapa id=${this.etapaId}`
      })
    },
    deleteRecord () {
      this.showDeleteSuccess()
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Etapa eliminada',
        text:
          `La Etapa "${this.etapaName}" ha sido eliminada del sistema.`
      })
    },
    closeSidebar () {
      this.$emit('closeEdit')
      this.initParams(true)
    },
    actionSaveData () {
      // this.initRelations();
      this.formerr = []

      if (
        this.casoData.id === null ||
        this.casoData.id === undefined ||
        this.casoData.id.toString().trim() === ''
      ) {
        this.formerr.push('casoId')
      }
      if (this.validateForm) {
        /*if (this.modeCreate) {
          console.log('*** 1 ***')
          //this._adjuntarArchivo()
        } else {
          console.log('*** 2 ***')
          //this.editetapa(this.etapa)
        }*/
        this._adjuntarArchivo()
      } else {
        this.$vs.dialog({
          color: 'danger',
          title: 'Error',
          text: 'Los datos del caso no son correctos.',
          acceptText: 'Aceptar'
        })
      }
    },
    _adjuntarArchivo () {
      const { id } = this.casoData

      
      let count = 0

      if (this.myFiles.length > 0) {
        this.$vs.loading()

        this.myFiles.forEach(file => {
          const payload = {
            idCaso: id,
            idUser: this.$store.state.auth.userDetails().id,
            files: file
          }

          this.$store
            .dispatch('CasoModule/addFilesCaso', payload)
            .then((result) => {

              const payload2 = {
                id_request: id,
                name_attachments: file.name,
                cloud_ubication: result.cloudUbi,
                create_id_user: payload.idUser
              }

              this.$store
                .dispatch('CasoModule/createFileCaso', payload2)
                .then(() => {

                  count++
                  if (count === this.myFiles.length) {
                    this.mostrarResultadoAdjuntArchivo('success', 'Aviso', 'Se adjuntaron los archivos con éxito.')
                  }
                }).catch(() => {
                  this.mostrarResultadoAdjuntArchivo('danger', 'Error', 'No se pudo crear los archivos, por favor vuelva a intentarlo.')
                })
            })
            .catch((error) => {
              console.log('addFilesCaso error, ', error)
              this.mostrarResultadoAdjuntArchivo('danger', 'Error', 'No se pudo adjuntar los archivos, por favor vuelva a intentarlo.')
            })
        })
      } else {
        this.mostrarResultadoAdjuntArchivo('warning', 'Aviso', 'No hay archivos para adjuntar.')
      }
    },
    mostrarResultadoAdjuntArchivo (type, title, text) {
      this.$vs.loading.close()

      if (type === 'success') {
        //this.$emit('refresh')
        //this.$emit('closeEdit')
        this.activePrompt2 = true
        this.infoConfirmText = text
      } else {
        this.$vs.dialog({
          color: type,
          title,
          text,
          acceptText: 'Aceptar'
        })
      }
    },
    editetapa (etapaData) {
      this.$store
        .dispatch('EtapaCasoModule/updateEtapa', etapaData)
        .then(() => {
          const etapaNameTmp = this.etapa.NOMBRE
          this.$emit('refresh')
          this.$emit('closeEdit')
          this.initParams(true) // Limpiar campos del formulario
          this.$vs.notify({
            color: 'success',
            title: 'Etapa actualizada',
            text:
              `La Etapa "${etapaNameTmp
              }" ha sido actualizada correctamente.`
          })
        })
        .catch((ex) => {
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOk !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    },
    onFromChange (selectedDates, dateStr, instance) {
      this.$set(this.configdateFin, 'minDate', dateStr)
    },
    onToChange (selectedDates, dateStr, instance) {
      this.$set(this.configdateIni, 'maxDate', dateStr)
    },
    handleFilePondInit () {
      console.log('FilePond has initialized')

      // FilePond instance methods are available on `this.$refs.pond`
    },
    handleFilePondAddFile (error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.push(file.file)
      
    },
    handleFilePondRemoveFile (error, file) {
      if (error) {
        return
      }
      //console.log('file', file)

      this.myFiles.map((item, index) => {
        if (item.name === file.filename) {
          this.myFiles.splice(index, 1)          
        }
      })
    },
    closeConfirmDialog () {
      location.reload()
    }
  }
}
</script>

<style lang="scss">
::v-deep .etapa-edit {
  height: 100%;
}

#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
